import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {getJSONFromHtml} from "../../../../domain/common";
import {ProductCompareWrapper} from "../interfaces";
import {getHiddenData} from "./data-provider";
import {parseDocumentIDs} from "../../../compare-bundles/domain/compare-bundles-provider";

interface StateInterface {
    test: number;
    documentIDs: number[];
    pcWrap: ProductCompareWrapper|null;
    isMutualHidden: boolean
}

const _documentIDs =parseDocumentIDs();
// initial state
const initialState: StateInterface = {
    test:1,
    documentIDs: _documentIDs,
    pcWrap: getHiddenData(_documentIDs),
    isMutualHidden:false
};

// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
